import React, { Component } from 'react'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import { Crumbs, Crumb } from 'components/BreadCrumbs'
import InfoCard from 'components/Cards/InfoCard'
import SimpleTable from 'components/Tables/SimpleTable'
import { PrettyJson } from 'components/PrettyJson'
import { moment } from 'features/Moment'
import { FlowLogEvent } from 'features/Flows/FlowLogEvent'

import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sAnim from 'components/Animation/Animation.scss'
import sMarg from 'styles/modules/margins.scss'

export default class FlowLog extends Component {
  componentWillMount() {
    const { getFlowLog, flowId, flowLogId, getFlows, flowsById } = this.props
    if (Object.keys(flowsById).length === 0) {
      getFlows()
    }
    getFlowLog({ flowId, flowLogId })
  }
  render() {
    const { flowId, flow, flowLog, flowLogId } = this.props

    return (
      <Page layout={{ header: 'app' }} title="Flows">
        <PageHeader>
          <Crumbs title="Flows">
            <Crumb parent to="/dashboard/flows">
              Flows
            </Crumb>
            <Crumb to={`/dashboard/flows/${flowId}`}>{flow && flow.name}</Crumb>
            <Crumb parent to={`/dashboard/flows/${flowId}/logs`}>
              Logs
            </Crumb>
            <Crumb active to={`/dashboard/flows/${flowId}/logs/${flowLogId}`}>
              Log: {flowLogId.slice(0, 6)}
            </Crumb>
          </Crumbs>
        </PageHeader>
        <Container paddingTop paddingBottom className={cn('md', sAnim.comeUp)}>
          <InfoCard title="Flow details" loading={!flowLog} className={sMarg.mb30}>
            {flowLog && (
              <SimpleTable className={sMarg.mb15}>
                <div>
                  <div>Triggered Time:</div>
                  <div>{moment(flowLog.created).format('DD MMM YYYY, h:mm:ss a')}</div>
                </div>
                <div>
                  <div>Related flow:</div>
                  <div>{flow.name}</div>
                </div>
              </SimpleTable>
            )}
            {flowLog && flowLog.env && flowLog.env.contact && (
              <PrettyJson className={sMarg.mb15} title="Contact" data={flowLog.env.contact} />
            )}
            {flowLog && flowLog.env && flowLog.env.call && (
              <PrettyJson className={sMarg.mb15} title="Call" data={flowLog.env.call} />
            )}
            {flowLog && flowLog.env && flowLog.env.message && (
              <PrettyJson className={sMarg.mb15} title="Message" data={flowLog.env.message} />
            )}
          </InfoCard>
          <div className={cn(sText.descrip2, sMarg.mb15)}>Flow Events:</div>
          {flowLog && flowLog.events.map((event, idx) => <FlowLogEvent event={event} key={idx} />)}
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/FlowLog/FlowLog.jsx